import { useEffect, useState } from 'react';

/**
 * Simple hook to monitor for long-running GraphQL queries
 * for diagnostic purposes only
 */
export function useGraphQLTimeout(
  isLoading: boolean,
  timeoutMs: number = 8000 // 8 seconds is a reasonable timeout
): string | null {
  const [timeoutWarning, setTimeoutWarning] = useState<string | null>(null);

  useEffect(() => {
    let timeoutId: number | undefined;
    
    if (isLoading) {
      // Set a timeout to log a warning if the query takes too long
      timeoutId = window.setTimeout(() => {
        const warning = 'GraphQL query is taking longer than expected';
        console.warn(warning);
        setTimeoutWarning(warning);
      }, timeoutMs);
    } else if (!isLoading) {
      // Clear warning when loading completes
      setTimeoutWarning(null);
    }
    
    // Clean up the timeout
    return () => {
      if (timeoutId) window.clearTimeout(timeoutId);
    };
  }, [isLoading, timeoutMs]);

  return timeoutWarning;
}